import { render, staticRenderFns } from "./sidebarmodeTab.vue?vue&type=template&id=6bff1d42&scoped=true&"
import script from "./sidebarmodeTab.vue?vue&type=script&lang=js&"
export * from "./sidebarmodeTab.vue?vue&type=script&lang=js&"
import style0 from "./sidebarmodeTab.vue?vue&type=style&index=0&id=6bff1d42&lang=less&scoped=true&"
import style1 from "./sidebarmodeTab.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bff1d42",
  null
  
)

export default component.exports